'use strict';
import NowLoading from '../libs/NowLoading';

class RegisterUserEvent {
    constructor(_store) {
        this.store = _store;
        this.registeruserUrl = '/login/register';

        $('#register').on('click', () => {
            if (this.store.valid() === true) {
                this.registerUser();
            } else {
                $('.modalHeaderText').text('入力エラー');
                $('.modalBodyText').text('ログインID（メールアドレス）が入力されていません');
                this.store.openWarningModal();
            }
        });
        this.nowLoading = new NowLoading();
    }

    registerUser() {
        this.nowLoading.dispLoading('処理中...');
        $.ajax({
            url: this.registeruserUrl,
            type: 'POST',
            data: this.store.data,
            dataType: 'json'
        }).done((data) => {
            $('.modalHeaderText').text(data['title']);
            $('.modalBodyText').text(data['message']);
            
            this.store.openWarningModal();

        }).fail((err) => {
            $('.modalHeaderText').text('通信エラー');
            $('.modalBodyText').text('サーバーとの通信に失敗しました。時間をおいて再試行をしてみて下さい');
        }).always((data) => {
            this.nowLoading.removeLoading();
        });
    }
}
export default RegisterUserEvent;